import React from "react";
import "./MiscFootballFieldPlayer.css";

import MiscFlag from "shared/components/misc/MiscFlag.js";
import MiscOverall from "shared/components/misc/MiscOverall.js";
import MiscPlayerAge from "shared/components/misc/MiscPlayerAge.js";
import { formations } from "shared/utils/formation.js";
import { getOverallColor } from "shared/utils/player.js";

interface MiscFootballFieldPlayerProps {
  teamMember: any;
  formation: string;
  onFieldPlayerView: string | null;
  onClick: () => void;
}

const MiscFootballFieldPlayer: React.FC<MiscFootballFieldPlayerProps> = ({
  teamMember: tm,
  formation,
  onFieldPlayerView,
  onClick,
}) => {
  return (
    <div className="misc-football-field-player" onClick={onClick}>
      <img
        className="misc-football-field-player__image"
        src={`https://d13e14gtps4iwl.cloudfront.net/players/v2/${tm.player.id}/photo.webp`}
        alt=""
      />

      <div className="misc-football-field-player__name">{tm.player.lastName}</div>

      <div className="misc-football-field-player__info">
        {(onFieldPlayerView == null || onFieldPlayerView === "ovr") && (
          <MiscOverall
            player={tm.player}
            actualPosition={formations[formation][tm.position].position.toString()}
            calculatedOvr={true}
          />
        )}

        {onFieldPlayerView === "profile" && (
          <div className="d-flex text-white">
            <MiscFlag country={tm.player.nationalities[0]} />
            &nbsp;<MiscPlayerAge age={tm.player.age} retirementYears={tm.player.retirementYears} compact />
            -{tm.player.height}
          </div>
        )}

        {onFieldPlayerView === "attr" && (
          <div className="misc-football-field-player__attrs text-white">
            {/* Line 1 */}
            <div className="d-flex">
              <div className="attr-cell">
                <span className="attr-label">P</span>
                <span style={{ color: getOverallColor(tm.player.pace) }}>{tm.player.pace}</span>
              </div>
              <div className="attr-cell">
                <span className="attr-label">P</span>
                <span style={{ color: getOverallColor(tm.player.passing) }}>{tm.player.passing}</span>
              </div>
              <div className="attr-cell">
                <span className="attr-label">D</span>
                <span style={{ color: getOverallColor(tm.player.defense) }}>{tm.player.defense}</span>
              </div>
            </div>

            {/* Line 2 */}
            <div className="d-flex">
              <div className="attr-cell">
                <span className="attr-label">S</span>
                <span style={{ color: getOverallColor(tm.player.shooting) }}>{tm.player.shooting}</span>
              </div>
              <div className="attr-cell">
                <span className="attr-label">D</span>
                <span style={{ color: getOverallColor(tm.player.dribbling) }}>{tm.player.dribbling}</span>
              </div>
              <div className="attr-cell">
                <span className="attr-label">P</span>
                <span style={{ color: getOverallColor(tm.player.physical) }}>{tm.player.physical}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MiscFootballFieldPlayer;
